import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { History } from "history";
import { ConnectedProps, connect } from "react-redux";
import Common from "us.common";
import { ConfigurationProvider } from "us.common/ConfigurationContext";
import commonRoutes from "us.common/routes";
import { SignalRProvider } from "us.common/SignalRProvider";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import reportingRoutes from "routes";
import { RootState } from "us.helper/types";
import { DrawerProvider } from "us.common/context";
import { Loader, LoginRedirect } from "us.common/components";
import { useAuth } from "us.helper/hooks/useAuth";

const { Page404, AppLayout, ConfigProvider } = Common.Components;

interface IAppProps {
  history: History;
  msalInstance: any;
}

const App: React.FC<IAppProps & PropsFromRedux> = ({
  msalInstance,
  currentLanguage,
  history,
}) => {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return (
      <UnauthenticatedTemplate>
        <BrowserRouter>
          <LoginRedirect />
        </BrowserRouter>
      </UnauthenticatedTemplate>
    );
  }

  return (
    <AuthenticatedTemplate>
      <BrowserRouter>
        <ConfigurationProvider>
          <SignalRProvider>
            <DrawerProvider>
              <AppLayout>
                <ConfigProvider locale={currentLanguage as any}>
                  <Routes>
                    {[...reportingRoutes(-1), ...commonRoutes]}
                    <Route path="*" element={<Page404 />} />
                  </Routes>
                </ConfigProvider>
              </AppLayout>
            </DrawerProvider>
          </SignalRProvider>
        </ConfigurationProvider>
      </BrowserRouter>
    </AuthenticatedTemplate>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    currentLanguage: state.common.currentLanguage,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);
